import PropTypes from "prop-types";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  InfoCircleFilled,
  LoadingOutlined,
} from "@ant-design/icons";
import { Spin } from "antd";

import { indexStatuses } from "./helper";

function IndexStatusIcon({ status }) {
  if (status === indexStatuses.in_progress) {
    return <Spin indicator={<LoadingOutlined spin />} size="small" />;
  }

  if (status === indexStatuses.yet_to_start) {
    return <InfoCircleFilled className="sps-status-icon-yet-to-start" />;
  }

  if (status === indexStatuses.failed) {
    return <CloseCircleFilled className="sps-status-icon-failed" />;
  }

  return <CheckCircleFilled className="sps-status-icon-completed" />;
}

IndexStatusIcon.propTypes = {
  status: PropTypes.string.isRequired,
};

export { IndexStatusIcon };
